import React, { useEffect, useState } from "react";
import axios from 'axios';
import OwlCarousel from "react-owl-carousel";
import ReactLoading from "react-loading";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

function Testimonials() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);



  const options = {
    loop: true,
    margin: 30,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 4000,
    smartSpeed: 800,
    navText: [
      '<i class="fa fa-chevron-left"></i>',
      '<i class="fa fa-chevron-right"></i>',
    ],
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1000: {
        items: 2,
      },
    },
  };

  useEffect(() => {
    getUsers();
  }, []);

  // Make an API request to the PHP server
  function getUsers() {
    setLoading(true);
    axios.get("https://yesedacademy.com/database/testimonial.php", {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    }).then((response) => {
      //console.log(response.data);
      setUsers(response.data);
      setLoading(false);
    })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  return (

    <div className="container-fluid bg-imageTest py-1">
      {/* Testimonial Start */}
      <div className="container py-1">
        <div className="row align-items-center">
          <div className="col-lg-5 mb-1 mb-lg-0">
            <div className="section-title position-relative mb-1">
              <h6 className="section-title-text d-inline-block position-relative text-uppercase pb-2">
                Testimonial
              </h6>

            </div>

          </div>
          <div className="col-lg-12">
            {loading ? (
              <div className='loading'> <ReactLoading type="spinningBubbles" color="#56148a"
                height={100} width={100} /></div>) : users.length > 0 ? (
                  <div className="carousel testimonial-carousel" >
                    <OwlCarousel controls indicators={false} className="testimonial-carousel" {...options}>
                      {users.map((user) => (
                        <div key={user.id}>
                          <div className=" p-3">
                            <i className="fa fa-3x fa-quote-left mb-4 quote-icon" ></i>
                            <p>{user.review}</p>
                            <div className="d-flex flex-shrink-0 align-items-center mt-4">
                              <img
                                className="img-fluid mr-4 shadow-1-strong"
                                src={user.image !== '' ? `https://yesedacademy.com/database/${user.image}` : `https://yesedacademy.com/database/images/user.png`}
                                alt="avatar"
                                style={{ width: 60, height: 60 }}
                              />
                              <div>
                                <h5>{user.name}</h5>
                                <span>
                                  {user.profession}
                                  {user.workplace !== ' ' && `, ${user.workplace}`}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </OwlCarousel>
                  </div>
                ) : (
              <p className="text-center text-muted">No testimonials found.</p>
            )}
          </div>
        </div>
      </div>
      {/* Testimonial End */}
    </div>

  );

}

export default Testimonials;
